import { Button, styled } from '@mui/material';

import { ReactComponent as CameraIcon } from 'assets/icons/blueCamera.svg';

export const CardW = styled('div')<{ privateView: boolean }>(({ theme }) => ({
  padding: '24px 28px 24px 28px',
  width: '100%',
  position: 'relative',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  background: 'rgba(255, 255, 255, 0.7)',
  backdropFilter: 'blur(20px)',
  overflow: 'hidden',
  border: `1px solid #dddddd`,

  [theme.breakpoints.down('desktop')]: {
    width: '100%',
    padding: '20px 16px',
  },
}));

export const HeaderRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const NameSection = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const NameText = styled('div')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '22px',
  lineHeight: '28px',
  color: theme.palette.primary.p080,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',

  [theme.breakpoints.down('desktop')]: {
    fontSize: '18px',
    lineHeight: '24px',
  },
}));

export const PositionText = styled('div')(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.primary.p040,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const EditButtonW = styled(Button)({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '20px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
});

export const LogoutButtonW = styled(Button)`
  text-transform: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  align-self: flex-start;
  margin-top: 4px;
`;

export const MobileCameraIcon = styled(CameraIcon)`
  position: absolute;
  z-index: 1;
  right: 0px;
`;

export const MoreW = styled('div')`
  position: absolute;
  bottom: 16px;
  right: 16px;
  cursor: pointer;
  margin-top: 8px;
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: underline;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const TextW = styled('p')`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.primary.main};
  margin: 0;
`;

export const MobileActionsW = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginTop: '16px',
});
